/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
import Flow from "components/Flow";
import { useRouter } from "next/router";
import React, { useEffect } from "react";
import segment from "lib/segment";

import TabularProgress from "components/TabularProgress";
import Media from "components/Media";
import StepProgress from "components/StepProgress";
import { ExtendedNextPage } from "types/pages";
import Topbar from "pages/components/Topbar";
import Footer from "pages/components/Footer";
import Content from "components/Content";
import FirstOff from "./components/FirstOff";
import ScheduleTime from "./components/BookATime";
import Services from "./components/Services";
import UserInfo from "./components/UserInfo";

import styles from "./styles.module.scss";

const LeadFlow: ExtendedNextPage = () => {
  const router = useRouter();

  const { query } = router;
  const { email, firstname, lastname, phone } = query;

  const initialValues = { email, firstname, lastname, phone };

  useEffect(() => {
    segment.track("LeadFlowStarted", initialValues);
  }, []);

  return (
    <Content containerClassName={styles.wrapper}>
      <Media at={["responsive"]}>
        <Flow
          contentClassName={styles.flowContent}
          initialFlowState={initialValues as { [key: string]: string }}
          className={styles.flow}
          Progress={StepProgress}
          showProgress
          withoutNextStepButton
          withoutPreviousStepButton
          steps={[
            {
              Component: FirstOff,
              key: "first off",
              progressLabel: "First off"
            },
            {
              Component: Services,
              key: "services",
              progressLabel: "Your home projects"
            },
            {
              Component: UserInfo,
              key: "confirmation",
              progressLabel: "Tell us about you"
            },
            {
              Component: ScheduleTime,
              key: "book a time",
              progressLabel: "Book a time"
            }
          ]}
        />
      </Media>
      <Media at={["desktop"]}>
        <Flow
          initialFlowState={initialValues as { [key: string]: string }}
          className={styles.flow}
          Progress={TabularProgress}
          showProgress
          withoutNextStepButton
          withoutPreviousStepButton
          steps={[
            {
              Component: FirstOff,
              key: "first-off",
              progressLabel: "First off"
            },
            {
              Component: Services,
              key: "services",
              progressLabel: "Your home projects"
            },
            {
              Component: UserInfo,
              key: "confirmation",
              progressLabel: "Tell us about you"
            },
            {
              Component: ScheduleTime,
              key: "book a time",
              progressLabel: "Book a time"
            }
          ]}
        />
      </Media>
    </Content>
  );
};

LeadFlow.getLayout = (page) => {
  return (
    <div>
      <Topbar />
      {page}
      <Footer />
    </div>
  );
};

export default LeadFlow;
